import { ApisauceInstance } from 'apisauce';

const getAdminUserList = (
  api: ApisauceInstance,
): Promise<(UserManagement.SignedUpUser | UserManagement.PendingUser)[]> => {
  return api
    .get<
      (UserManagement.SignedUpUser | UserManagement.PendingUser)[]
    >('/v1/users/adminList')
    .then((response) => {
      if (response.ok && response.data) {
        return response.data;
      }
      return [];
    });
};

export default getAdminUserList;
